module.exports = "/images/ml.svg?3bd32a7941e5090b8e7ea3b717c2e61f";